import { useEffect, useState } from 'react';

/**
 * Once `enabled` is true for a uid, stay latched until that uid signs out.
 * Used so account-menu listeners do not unsubscribe (and re-bill) on close.
 */
export function useListenerLatch(uid: string | null | undefined, enabled: boolean): boolean {
  const [latched, setLatched] = useState(false);

  useEffect(() => {
    if (!uid) {
      setLatched(false);
      return;
    }
    if (enabled) setLatched(true);
  }, [uid, enabled]);

  return Boolean(uid && latched);
}
